import { Action } from 'redux';

import { NewWorkbookForEditDatasource } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../ts/models/IContentInfo';


export interface EditDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function editDatasource(contentInfo: IContentInfo): EditDatasourceAction {
  return {
    type: NewWorkbookForEditDatasource,
    contentInfo
  };
}

export const isEditDatasourceAction = isActionFactory<EditDatasourceAction>(NewWorkbookForEditDatasource);
